export default {
    parameters: {
        landing_id: "TrSpGtsAtest",
    },
    downtimeUrl: "https://www.kodland.org/tr",
    title: "3 soruyu yanıtlayın ve ÜCRETSİZ eğlenceli bir matematik dersi alın | Kodland",
    startPage: {
        startBackground: "#D6FF6B",
        quizBackground: "#white",
        title: '<div><b>3 kısa soruya yanıt verin ve ÜCRETSİZ matematik dersinizi alın!</div></b>',
        subtitle: 'Çocuğunuzun hangi seviyede olduğunu görün, zayıf yönlerini nasıl güçlendirebileceğinizi öğrenin ve ona matematiği sevmesi için güven ve motivasyon kazandırın — okul ve LGS sınavlarına mükemmel hazırlık.',
        image: {
            url: "/welcome/quiz_turkey_math_active_pk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        button: {
            text: "Ücretsiz almak için tıklayın",
            style: {
                background: "#5988FF",
                color: "#FFFFFF",
                "font-weight": "bold",
            },
        },
        imageMobile: {
            url: "/welcome/quiz_turkey_math_active_mb.png",
            style: {
                width: "100%",
            },
        },
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuz şu anda matematik hakkında nasıl hissediyor?",
            answers: [
                "😟 Çocuğum matematikte zorlanıyor ve bu konuda genelde endişe duyuyor",
                "😐 Çocuğum matematiği sevmiyor ve çalışmak için motivasyonu düşük",
                "🙂 Çocuğum fena değil ama bazı konularda eksikleri var",
                "🤓 Çocuğum matematiği seviyor ve yeni zorluklar arıyor"
            ]
        },
        2: {
            question: "Çocuğunuz LGS’ye ne zaman girecek?",
            answers: [
                "🚨 2026’da",
                "⚠️ 2027’de",
                "⏳ 2028’de",
                "📅 2029’da",
                "🤔 Henüz emin değilim"
            ],
        },
        3: {
            question: "Ücretsiz matematik dersinde ulaşmak istediğiniz en önemli hedef nedir?",
            answers: [
                "🚀 Çocuğumun matematiğe karşı ilgisini ve motivasyonunu artırmak",
                "💖 Çocuğumun stresini azaltıp özgüvenini güçlendirmek",
                "🔍 Çocuğumun mevcut matematik seviyesini ve geliştirilmesi gereken alanları öğrenmek",
                "🥇 LGS matematik hazırlığı için en iyi stratejiyi öğrenmek"
            ],
        },
        4: {
            title: "Çocuğunuzun Yaşını Seçin",
            subtitle: "Uzman öğretmenlerimiz, çocuğunuzun matematik özgüveni kazanmasını ve okul performansını artırmasını sağlar.",
            type: "age",
            button: "İleri 🚀",
        },
        5: {
            question:
                "Çocuğunuzun çevrim içi dersler için bir bilgisayara (masaüstü veya dizüstü) erişimi var mı?",
            answers: [
                "👍 Evet",
                {
                    answer: "👎 Hayır",
                    stopAnswer: true,
                },
            ],
        },

        6: {
            title: "Deneme dersi için hangi saatte uygunsunuz?",
            type: "timeslot",
            subtitle:
                "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
            button: "Rezervasyon için tıklayın 🎁",
        },

        7: {
            title: "İsminizi girin",
            type: "parent_name",
            subtitle: "Bizim adımız Kodland, sizinki ne?👋",
            button: "İleri 🚀",
        },
        8: {
            title: "E-postanızı girin",
            type: "mail",
            subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
            button: "İleri 🚀",
        },
        9: {
            title: "Telefon numaranızı girin",
            type: "phone",
            subtitle: "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
            button: "Neredeyse bitti 🔥",
        },
        10: {
            title: "Çocuğunuzun adı nedir?",
            type: "child_name",
            subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir🚨",
            button: "Son adım! 🎉",
        },
    },
};
